import component from './component'

export default {
    path: '/diplomas',
    name: 'diplomas',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/diplomas/index/index.js